<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="modems"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :externalFilters="externalFilters"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">Активные модемы</h2>
        <div class="input-group mr-1" style="max-width: 27em">
          <div class="input-group-prepend">
            <span class="input-group-text">UID модема</span>
          </div>
          <input type="text" class="form-control"  v-model="uidFilter">
        </div>
        <button class="btn btn-sm btn-outline-primary mr-2" @click="save">Применить</button>
        <button class="btn btn-outline-primary mr-2" @click="commandsBroadcast()" v-if="data">Рассылка команд</button>
        <button class="btn btn-primary mr-2" @click="newModem()" v-if="canEdit">Добавить модем</button>
        <btn-filters
          :data="data"
          endpoint="modems"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>
    <template v-if="data && data.data">
      <data-table-full-height
        :data="modems"
        @sort-change="sortChange"
        @load-more="loadMore"
        :hasMore="hasMore"
        :loading="loading"
        @filter-change="filterChange"
      >
        <el-table-column prop="uid" label="№ модема" sortable="custom" width="200">
          <template slot-scope="{row}">

            <router-link :to="`/modems/${row.uid}`" v-if="canEdit">
              <div>{{ row.number }}</div>
              <div><small>{{ row.uid }}</small></div>
            </router-link>

            <div v-else>
              <div>{{ row.number }}</div>
              <div><small>{{ row.uid }}</small></div>
            </div>

          </template>
        </el-table-column>
        <table-column-serial-number prop="machines.serial_number" machine-prop="machine" sortable="custom"/>
        <el-table-column label="SIM">
          <template slot-scope="{row}">
            <div v-if="row.data && row.data.sim">SIM-карта: {{ row.data.sim }}</div>
            <div v-if="row.data && row.data.simchip">SIM-чип: {{ row.data.simchip }}</div>
          </template>
        </el-table-column>
        <el-table-column  v-if="$root.isAdmin()" prop="region.short_name" label="Организация"
                          :filters="regionFilters"
                          column-key="region_id"
                          filter-placement="bottom-start"/>
        <table-column-date prop="last_command_at" label="Последняя команда" sortable="custom"/>
        <el-table-column label="Редактировать" width="180" align="center" v-if="canEdit">
          <template slot-scope="{row}">
            <button class="btn btn-sm btn-outline-light" @click.stop="edit(row)">Редактировать</button>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import EditModal from '../../../components/modems/edit-modal.vue'
  import BroadcastModal from '../../../components/modems/broadcast-modal.vue'
  import api from '@/api'

  export default {
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: {prop: 'uid', order: 'asc'},
        updateList: 0,
        uidFilter: null,
        externalFilters: null,
        regionFilters: [],
      }
    },
    computed: {
      modems () {
        return this.data.data
      },
      canEdit () {
        return this.$root.checkPermission('web_modems_edit')
      },
    },
    methods: {
      newModem () {
        this.$root.showModal(EditModal, {id: null, uid: null, newModem: true}).then((value) => {
          if (value) {
            this.modems.unshift({
              id: value.modemId,
              uid: value.uid,
              region: value.region,
            })
          }
        })
      },
      edit (modem) {
        let noCommands = modem.last_command_at === null
        this.$root.showModal(EditModal, {
          id: modem.id,
          currentRegion: modem.region,
          uid: modem.uid,
          noCommands: noCommands,
          number: modem.number,
        }).then((value) => {
          if (value) {
            this.modems.forEach(function (item) {
              if (item.id === value.modemId) {
                item.region = value.region
              }
            })
          }
        })
      },
      commandsBroadcast () {
        this.$root.showModal(BroadcastModal, {
          filters: this.filtersValue,
          total: this.data.total,
        })
      },
      loadMore () {
        this.$refs.data.loadMore()
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = {
            prop: sort.prop,
            order,
          }
        } else {
          this.sort = null
        }
      },
      filterChange (filter) {
        this.externalFilters = filter
      },
      save () {
        let data = {}
        if (this.uidFilter) data.uid = this.uidFilter
        this.externalFilters = data
      },
    },
    asyncComputed: {
      filters () {
        if (this.$root.isAdmin()) {
          api.get('regions/options', {
            params: {field: 'short_name'},
          }).then(data => {
            this.regionFilters = data.data.data.map((el) => {
              return {
                value: el.id,
                text: el.short_name,
              }
            })
          })
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/index/index.vue